import sum from './sum'

const items = [
  {
    name: 'infantCarSeat',
    label: 'Infant car seat',
    description: 'Infant car seats typically range anywhere from $100-$300.',
    enabled: true,
    value: 150,
  },
  {
    name: 'convertibleCarSeat',
    label: 'Convertible car seat',
    description: 'Convertible car seats typically range anywhere from $100-$299.',
    enabled: true,
    value: 150,
  },
  {
    name: 'boosterSeat',
    label: 'Booster seat',
    description: 'Booster seats typically range anywhere from $50-$300.',
    enabled: false,
    value: 150,
  },
  {
    name: 'stroller',
    label: 'Stroller',
    description: 'Strollers typically range anywhere from $200-$1500.',
    enabled: false,
    value: 500,
  },
]


export default {
  name: 'transportation',
  label: 'Transportation',
  enabled: true,
  value: sum(items),
  on: true,
  items,
}
